import * as React from 'react';
import './Login.less';
import { Form, Input, Button, Select, Divider, message, Spin, Checkbox, Tooltip, Row, Col } from 'antd';
import { FormComponentProps } from 'antd/lib/form/Form';
import { RouteComponentProps, withRouter, Link, Redirect } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import SVGComponent, { FilterType } from '../../components/common/SVGComponent';
import { PageProps } from 'src/models/common/ComponentProps';
import ResetPasswordDTO from 'src/models/account/ResetPasswordDTO';
import AccountApiController from 'src/api/AccountApiController';

const logo = require('src/assets/branding/logo.png');

interface RouteParams {
    userId: string;
    resetPasswordId: string;
}

interface ResetPasswordProps extends PageProps<RouteParams>, FormComponentProps, LocalizeContextProps { }

interface ResetPasswordState {
    isSubmitting: boolean;
}

class ResetPassword extends React.Component<ResetPasswordProps, ResetPasswordState> {
    constructor(props: ResetPasswordProps) {
        super(props);
        bindAllOfThis(this, ResetPassword.prototype);

        this.state = {
            isSubmitting: false
        };
    }

    private handleSubmit(e): void {
        e.preventDefault();

        this.props.form.validateFields((error: any, values: any) => {
            if (!error) {
                this.setState({
                    isSubmitting: true
                });

                let userId = parseInt(this.props.match.params.userId, 10);
                let resetPasswordId = this.props.match.params.resetPasswordId;
                let resetPasswordDTO = { ...values, ...{ "userId": userId, "resetPasswordId": resetPasswordId } };

                AccountApiController.selfServePasswordReset(resetPasswordDTO).then(result => {
                    this.setState({
                        isSubmitting: true
                    });

                    message.success(this.props.translate('account.resetPassword.messageReset'));
                    this.props.history.push(Routes.LOGIN);
                });
            }
        });
    }

    compareToFirstPassword = (rule, value, callback) => {
        if (value && value !== this.props.form.getFieldValue('newPassword')) {
            callback(this.props.translate('account.resetPassword.saveTooltip').toString());
        } else {
            callback();
        }
    }

    validateToNextPassword = (rule, value, callback) => {
        if (this.props.form.getFieldValue('confirmPassword')) {
            this.props.form.validateFields(['confirmPassword'], { force: true }, (errors, values) => console.log('Revalidating'));
        }
        callback();
    }

    render() {
        let passwordMinLength = 8;

        return <div>
            <Row type="flex" justify="center">
                <Col xs={22} sm={22} md={18} lg={14} xl={11} className="login-form">
                    <Link to={Routes.BASE_ROUTE} className="logo" tabIndex={-1}>
                        <img src={logo} alt="Kuder Galaxy" height="100%" width="100%" tabIndex={-1} />
                    </Link>
                    <Form hideRequiredMark onSubmit={this.handleSubmit}>
                        <h3>{this.props.translate('account.resetPassword.header')}</h3>
                        <Form.Item>
                            {
                                this.props.form.getFieldDecorator('newPassword',
                                    {
                                        rules: [
                                            { required: true, message: this.props.translate("admin.common.requiredRule").toString() },
                                            { min: passwordMinLength, message: this.props.translate("admin.common.minLengthRule").toString() + passwordMinLength },
                                            { validator: this.validateToNextPassword }
                                        ]
                                    })
                                    (<Input type="password" size="large" placeholder={this.props.translate("account.resetPassword.formItem1").toString()} />)
                            }
                        </Form.Item>
                        <Form.Item>
                            {
                                this.props.form.getFieldDecorator('confirmPassword',
                                    {
                                        rules: [
                                            { required: true, message: this.props.translate("admin.common.requiredRule").toString() },
                                            { validator: this.compareToFirstPassword }
                                        ]
                                    })
                                    (<Input type="password" size="large" placeholder={this.props.translate("account.resetPassword.formItem2").toString()}  />)
                            }
                        </Form.Item>
                        <Form.Item>
                            <Button loading={this.state.isSubmitting} size="large" type="primary" htmlType="submit">
                                {!this.state.isSubmitting && this.props.translate("account.resetPassword.button1")}
                            </Button>
                        </Form.Item>
                    </Form>
                    <br />
                    <Form.Item>
                        <Link to={Routes.LOGIN}>
                            <Button className="ant-btn ant-btn-lg">
                                {this.props.translate("account.resetPassword.button2")}
                            </Button>
                        </Link>
                    </Form.Item>
                </Col>
            </Row>
        </div>;
    }
}

export default withLocalize(Form.create()(ResetPassword));



// WEBPACK FOOTER //
// ./src/pages/account/ResetPassword.tsx